function g(n) {
  return b(n) || h(n) || A(n) || d();
}
function d() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function A(n, r) {
  if (n) {
    if (typeof n == "string") return l(n, r);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return l(n, r);
  }
}
function h(n) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(n)) return Array.from(n);
}
function b(n) {
  if (Array.isArray(n)) return l(n);
}
function l(n, r) {
  (r == null || r > n.length) && (r = n.length);
  for (var t = 0, e = new Array(r); t < r; t++)
    e[t] = n[t];
  return e;
}
var w = function(r) {
  return r;
}, m = {}, p = function(r) {
  return r === m;
}, v = function(r) {
  return function t() {
    return arguments.length === 0 || arguments.length === 1 && p(arguments.length <= 0 ? void 0 : arguments[0]) ? t : r.apply(void 0, arguments);
  };
}, j = function n(r, t) {
  return r === 1 ? t : v(function() {
    for (var e = arguments.length, u = new Array(e), a = 0; a < e; a++)
      u[a] = arguments[a];
    var o = u.filter(function(i) {
      return i !== m;
    }).length;
    return o >= r ? t.apply(void 0, u) : n(r - o, v(function() {
      for (var i = arguments.length, c = new Array(i), f = 0; f < i; f++)
        c[f] = arguments[f];
      var y = u.map(function(s) {
        return p(s) ? c.shift() : s;
      });
      return t.apply(void 0, g(y).concat(c));
    }));
  });
}, S = function(r) {
  return j(r.length, r);
}, I = function(r, t) {
  for (var e = [], u = r; u < t; ++u)
    e[u - r] = u;
  return e;
}, O = S(function(n, r) {
  return Array.isArray(r) ? r.map(n) : Object.keys(r).map(function(t) {
    return r[t];
  }).map(n);
}), H = function() {
  for (var r = arguments.length, t = new Array(r), e = 0; e < r; e++)
    t[e] = arguments[e];
  if (!t.length)
    return w;
  var u = t.reverse(), a = u[0], o = u.slice(1);
  return function() {
    return o.reduce(function(i, c) {
      return c(i);
    }, a.apply(void 0, arguments));
  };
}, T = function(r) {
  return Array.isArray(r) ? r.reverse() : r.split("").reverse.join("");
}, C = function(r) {
  var t = null, e = null;
  return function() {
    for (var u = arguments.length, a = new Array(u), o = 0; o < u; o++)
      a[o] = arguments[o];
    return t && a.every(function(i, c) {
      return i === t[c];
    }) || (t = a, e = r.apply(void 0, a)), e;
  };
};
export {
  m as PLACE_HOLDER,
  H as compose,
  S as curry,
  O as map,
  C as memoize,
  I as range,
  T as reverse
};
